/* The Honest Home — normal-only eligibility; Kaching bundle blocks gift (v6)
 * Eligibility: exactly 4 paid normal units, paid subtotal >= INR 800,
 * Any Kaching bundle makes cart ineligible. Removes the Free Gift variant when ineligible.
 * Pricing/discounts remain Shopify's responsibility.
 */
(function () {
  'use strict';
  if (window.__hhGiftControllerV6) return;
  window.__hhGiftControllerV6 = true;

  var GIFT_ID = 67622382043267;
  var BUNDLE_IDS = [67738471170179]; // Known Kaching Cross Product parent
  var EXACT_QTY = 4;
  var MIN_PAISE = 80000;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/?$/, '/');
  var rawFetch = window.fetch.bind(window);
  var busy = false, queued = false, timer = null, lastErrorAt = 0;
  var lastMutationAt = 0;

  function readCart() {
    return rawFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw Error('cart.js: HTTP ' + r.status); return r.json(); });
  }
  function changeCart(key, quantity) {
    return rawFetch(root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { if (!r.ok) throw Error('change.js: HTTP ' + r.status); return r.json(); });
  }
  function addGift() {
    return rawFetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_ID, quantity: 1, properties: { _free_gift: 'true' } }] })
    }).then(function (r) { if (!r.ok) throw Error('add.js: HTTP ' + r.status); return r.json(); });
  }
  function isGift(i) { return Number(i.variant_id) === GIFT_ID; }
  function isBundle(i) {
    return i.has_components === true || BUNDLE_IDS.indexOf(Number(i.variant_id)) !== -1 ||
      (Array.isArray(i.components) && i.components.length > 0) ||
      (Array.isArray(i.item_components) && i.item_components.length > 0);
  }
  function eligible(cart) {
    var paid = cart.items.filter(function (i) { return !isGift(i); });
    if (paid.some(isBundle)) return false;
    paid = paid.filter(function (i) { return !isBundle(i); });
    var qty = paid.reduce(function (n, i) { return n + (Number(i.quantity) || 0); }, 0);
    var subtotal = paid.reduce(function (n, i) { return n + (Number(i.final_line_price) || 0); }, 0);
    return qty === EXACT_QTY && subtotal >= MIN_PAISE;
  }
  function notify(cart) {
    var event = new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } });
    document.documentElement.dispatchEvent(event);
    // Shopify cart page needs fresh Liquid-rendered rows; drawer listens for cart:refresh.
    if (location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, '')) {
      location.reload();
    }
  }
  async function sync() {
    if (busy) { queued = true; return; }
    if (Date.now() - lastErrorAt < 5000) return;
    busy = true;
    try {
      var cart = await readCart();
      var allowed = eligible(cart);
      var gifts = cart.items.filter(isGift);
      var changed = false;
      if (!allowed) {
        // Offer product must not remain in either cart view when offer is invalid.
        // This also removes manually-added copies of this dedicated Free Gift variant.
        for (var i = 0; i < gifts.length; i++) {
          await changeCart(gifts[i].key, 0);
          changed = true;
        }
      } else if (!gifts.length) {
        await addGift();
        changed = true;
      } else {
        // Enforce exactly one gift line / unit.
        for (var j = 0; j < gifts.length; j++) {
          if (j > 0) { await changeCart(gifts[j].key, 0); changed = true; }
          else if (Number(gifts[j].quantity) !== 1) {
            await changeCart(gifts[j].key, 1); changed = true;
          }
        }
      }
      if (changed) notify(await readCart());
    } catch (err) {
      lastErrorAt = Date.now();
      console.warn('[Honest Home gift]', err);
    } finally {
      busy = false;
      if (queued) { queued = false; schedule(450); }
    }
  }
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay == null ? 500 : delay);
  }
  function cartWriteUrl(url) {
    return /(?:^|\/)cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(String(url || ''));
  }
  // Track fetch-based cart edits (Kaching and theme may use different transports).
  var originalFetch = window.fetch;
  window.fetch = function () {
    var first = arguments[0];
    var url = typeof first === 'string' ? first : (first && first.url) || '';
    var response = originalFetch.apply(this, arguments);
    if (cartWriteUrl(url)) {
      Promise.resolve(response).then(function (r) { if (r && r.ok) schedule(600); }).catch(function () {});
    }
    return response;
  };
  // Track XMLHttpRequest-based cart edits.
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hhCartWrite = cartWriteUrl(url) && String(method).toUpperCase() !== 'GET';
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__hhCartWrite) {
      this.addEventListener('loadend', function () {
        if (this.status >= 200 && this.status < 300) schedule(600);
      });
    }
    return xhrSend.apply(this, arguments);
  };
  // Catch non-AJAX form submissions after next page load and tab restores.
  document.addEventListener('DOMContentLoaded', function () { schedule(150); }, { once: true });
  if (document.readyState !== 'loading') schedule(150);
  window.addEventListener('pageshow', function () { schedule(200); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(200); });
  // Fallback for third-party cart changes not visible through fetch/XHR wrappers.
  setInterval(function () { if (!document.hidden) schedule(150); }, 5000);
})();
